import { useCallback, useState } from "react";
import { useAuth } from "../../shared/contexts/AuthContext";
import { useOnboarding } from "./OnboardingContext";
import { useOnboardingSheet } from "./OnboardingSheet";

export function useEditStepSave({ saveDisabled = false } = {}) {
  const { user } = useAuth();
  const { completeOnboarding, isEditMode, showSaveSuccessAndExit } = useOnboarding();
  const { requestCloseTo } = useOnboardingSheet();
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);

  const handleSave = useCallback(async () => {
    if (isSaving || saveDisabled) return;

    setSaveError(null);
    setIsSaving(true);

    const result = await completeOnboarding(user?.id ?? "me");
    setIsSaving(false);

    if (!result.ok) {
      setSaveError(result.error || "Could not save your profile. Please try again.");
      return;
    }

    showSaveSuccessAndExit(() => {
      requestCloseTo("/profile-details");
    });
  }, [
    completeOnboarding,
    isSaving,
    requestCloseTo,
    saveDisabled,
    showSaveSuccessAndExit,
    user?.id,
  ]);

  return {
    showSave: isEditMode,
    onSave: handleSave,
    saveDisabled: saveDisabled || isSaving,
    saveLabel: isSaving ? "Saving…" : "Save",
    isSaving,
    saveError,
  };
}
